import React from "react"

export function Office(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_324_6072)">
        <path
          d="M1.3125 0C0.587891 0 0 0.587891 0 1.3125V12.6875C0 13.4121 0.587891 14 1.3125 14H3.9375V11.8125C3.9375 11.0879 4.52539 10.5 5.25 10.5C5.97461 10.5 6.5625 11.0879 6.5625 11.8125V14H9.1875C9.91211 14 10.5 13.4121 10.5 12.6875V1.3125C10.5 0.587891 9.91211 0 9.1875 0H1.3125ZM1.75 6.5625C1.75 6.32188 1.94687 6.125 2.1875 6.125H3.0625C3.30312 6.125 3.5 6.32188 3.5 6.5625V7.4375C3.5 7.67812 3.30312 7.875 3.0625 7.875H2.1875C1.94687 7.875 1.75 7.67812 1.75 7.4375V6.5625ZM4.8125 6.125H5.6875C5.92812 6.125 6.125 6.32188 6.125 6.5625V7.4375C6.125 7.67812 5.92812 7.875 5.6875 7.875H4.8125C4.57188 7.875 4.375 7.67812 4.375 7.4375V6.5625C4.375 6.32188 4.57188 6.125 4.8125 6.125ZM7 6.5625C7 6.32188 7.19688 6.125 7.4375 6.125H8.3125C8.55313 6.125 8.75 6.32188 8.75 6.5625V7.4375C8.75 7.67812 8.55313 7.875 8.3125 7.875H7.4375C7.19688 7.875 7 7.67812 7 7.4375V6.5625ZM2.1875 2.625H3.0625C3.30312 2.625 3.5 2.82188 3.5 3.0625V3.9375C3.5 4.17812 3.30312 4.375 3.0625 4.375H2.1875C1.94687 4.375 1.75 4.17812 1.75 3.9375V3.0625C1.75 2.82188 1.94687 2.625 2.1875 2.625ZM4.375 3.0625C4.375 2.82188 4.57188 2.625 4.8125 2.625H5.6875C5.92812 2.625 6.125 2.82188 6.125 3.0625V3.9375C6.125 4.17812 5.92812 4.375 5.6875 4.375H4.8125C4.57188 4.375 4.375 4.17812 4.375 3.9375V3.0625ZM7.4375 2.625H8.3125C8.55313 2.625 8.75 2.82188 8.75 3.0625V3.9375C8.75 4.17812 8.55313 4.375 8.3125 4.375H7.4375C7.19688 4.375 7 4.17812 7 3.9375V3.0625C7 2.82188 7.19688 2.625 7.4375 2.625Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_324_6072">
          <path d="M0 0H10.5V14H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
